import { render } from "./Wip.vue?vue&type=template&id=d4d64d10"
import script from "./Wip.vue?vue&type=script&lang=js"
export * from "./Wip.vue?vue&type=script&lang=js"
script.render = render

export default script